module.exports = __webpack_public_path__ + "img/freesound_button.55d64a17.png";